import { render, staticRenderFns } from "./brokersettlement.vue?vue&type=template&id=6c6e9274"
import script from "./brokersettlement.vue?vue&type=script&lang=js"
export * from "./brokersettlement.vue?vue&type=script&lang=js"
import style0 from "./brokersettlement.vue?vue&type=style&index=0&id=6c6e9274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports